(() => {
  const rootSelector = '[data-out-of-stock-contact]';
  const optionSelector = '[data-out-of-stock-contact-option]';
  let updateQueue = Promise.resolve();
  let persistedValue = '';
  let saveFailed = false;

  const getRoot = () => document.querySelector(rootSelector);

  const getValue = (root) =>
    [...root.querySelectorAll(`${optionSelector}:checked`)].map(({ value }) => value).join(', ');

  const setError = (root, message) => {
    const error = root.querySelector('[data-out-of-stock-contact-error]');
    const show = Boolean(message);
    if (error) {
      error.textContent = message || '';
      error.hidden = !show;
    }
    root.querySelectorAll(optionSelector).forEach((option) =>
      option.setAttribute('aria-invalid', show ? 'true' : 'false')
    );
    root.toggleAttribute('data-invalid', show);
    window.DancingOaksCartValidation?.notify();
  };

  const syncField = (root) => {
    const value = getValue(root);
    const field = root.querySelector('[data-out-of-stock-contact-value]');
    if (field) field.value = value;
    return value;
  };

  const saveAttribute = (value) => {
    updateQueue = updateQueue.catch(() => {}).then(() =>
      Promise.resolve(window.DancingOaksCartValidation?.whenReset?.())
        .catch(() => {})
        .then(() => fetch(window.routes?.cart_update_url || '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Out-of-stock contact': value } }),
        }))
        .then((response) => {
          if (!response.ok) throw new Error('Unable to save contact preference');
          return response.json();
        })
        .then((cart) => {
          persistedValue = cart.attributes?.['Out-of-stock contact'] ?? value;
          saveFailed = false;
          return cart;
        })
        .catch((error) => {
          saveFailed = true;
          throw error;
        })
    );
    return updateQueue;
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches(optionSelector)) return;
    const root = event.target.closest(rootSelector);
    const value = syncField(root);
    if (value) setError(root, '');
    saveAttribute(value)
      .then(() => {
        if (value) setError(root, '');
      })
      .catch(() => {
        setError(root, 'We could not save your contact preference. Please try again.');
      });
  });

  const initialRoot = getRoot();
  if (initialRoot) persistedValue = syncField(initialRoot);

  window.DancingOaksCartValidation?.register('contact', {
    message: 'Please select at least one way we can contact you if an item is unexpectedly unavailable.',
    persistenceError: 'We could not save your contact preference. Please try again.',
    root: getRoot,
    focusTarget: () => getRoot()?.querySelector(optionSelector),
    whenSettled: () => updateQueue,
    validate: () => {
      const root = getRoot();
      if (!root) return false;
      const value = syncField(root);
      return {
        valid: Boolean(value) && !saveFailed && persistedValue === value,
        message: saveFailed
          ? 'We could not save your contact preference. Please try again.'
          : 'Please select at least one way we can contact you if an item is unexpectedly unavailable.',
      };
    },
    showError: (message) => {
      const root = getRoot();
      if (root) setError(root, message);
    },
    clearError: () => {
      const root = getRoot();
      if (root) setError(root, '');
    },
    reset: () => {
      const root = getRoot();
      if (!root) return;
      root.querySelectorAll(optionSelector).forEach((option) => {
        option.checked = false;
        option.setAttribute('aria-invalid', 'false');
      });
      syncField(root);
      persistedValue = '';
      saveFailed = false;
      setError(root, '');
    },
  });
})();
